export const usagePolicyRoutes = [
  {
    path: '/configuracoes/politicas-de-uso',
    name: 'UsagePolicies',
    meta: {
      requiresAuth: true,
      menu: true,
      navbarActions: true,
      chat: true,
      path: 'config'
    },
    component: () => import(/* webpackChunkName: 'usage-policies-page' */ 'views/UsagePoliciesPage')
  }
]
